export enum BackendFileType {
  ADVERSE_DRUG_PETITION = 'AdverseDrugPetition',
  COMPLIANCE_PROTOCOL_DOCS = 'ComplianceProtocolDocs',
  CONFIRMING_DOCUMENT = 'ConfirmingDocument',
  CONSIGNMENT = 'Consignment',
  EPGU_REGISTRY = 'EpguRegistry',
  EXPERT_OPINION = 'ExpertOpinion',
  GMP_COMPLIANCE_CONCLUSION_DOCS = 'GmpComplianceConclusionDocs',
  INSTRUCTION = 'Instruction',
  LAYOUT = 'Layout',
  NORMATIVE_DOCUMENT = 'NormativeDocument',
  OPERATING_INSTRUCTION = 'OperatingInstruction',
  PERIODIC_SCHEDULE_REPORT = 'PeriodicScheduleReport',
  PHARMACEUTICAL_IMAGE = 'PharmaceuticalImage',
  PHARMACEUTICAL_PERMISSION_DOCS = 'PharmaceuticalPermissionDocs',
  PRESCRIPTION = 'Prescription',
  REGISTRATION_CERTIFICATE = 'RegistrationCertificate',
  REQUEST_DOCUMENT = 'RequestDocument',
  SECONDARY_LAYOUT = 'SecondaryLayout',
  TEMPORARY = 'Temporary',
  INSPECTOR = 'Inspector',
  FAKE = 'FakePharmaceutical',
  PARAMETER = 'Parameter',
}

export enum FileMimeType {
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  BMP = 'image/bmp',
  GIF = 'image/gif',
  TIFF = 'image/tiff',
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  XML = 'application/xml',
  XZIP = 'application/x-zip-compressed',
}

export type FileTypeOptions = {
  type: FileMimeType;
  name: string;
};

export const fileTypes: FileTypeOptions[] = [
  {
    name: 'doc',
    type: FileMimeType.DOC,
  },
  {
    name: 'docx',
    type: FileMimeType.DOCX,
  },
  {
    name: 'jpeg',
    type: FileMimeType.JPEG,
  },
  {
    name: 'png',
    type: FileMimeType.PNG,
  },
  {
    name: 'tiff',
    type: FileMimeType.TIFF,
  },
  {
    name: 'pdf',
    type: FileMimeType.PDF,
  },
  {
    name: 'zip',
    type: FileMimeType.ZIP,
  },
  {
    name: 'xml',
    type: FileMimeType.XML,
  },
  {
    name: 'xzip',
    type: FileMimeType.XZIP,
  },
  {
    name: 'bmp',
    type: FileMimeType.BMP,
  },
  {
    name: 'gif',
    type: FileMimeType.GIF,
  },
];

export const defaultAcceptedFileTypes: FileMimeType[] = [
  FileMimeType.DOC,
  FileMimeType.DOCX,
  FileMimeType.JPEG,
  FileMimeType.PNG,
  FileMimeType.TIFF,
  FileMimeType.PDF,
  FileMimeType.ZIP,
  FileMimeType.XZIP,
];
